angular.module('zc.core')
  .factory('chronologicalChartV2Config', chronologicalChartV2Config);

chronologicalChartV2Config.$inject = ['$translate', '$window', 'baseChartV2Config'];
function chronologicalChartV2Config($translate, $window, baseChartV2Config) {
  return angular.merge({
    options: {
      colors: ['#26c9ff', '#666666'],
      tooltip: {
        shared: true,
        crosshairs: true,
        dateTimeLabelFormats: {
          hour: $translate.instant('sharedModules.dateTimeFormats.chart.monthDayHour'),
          day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
          week: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
        }
      },
      plotOptions: {
        series: {
          marker: {
            symbol: 'circle',
            enabled: false
          }
        }
      }
    },
    xAxis: {
      title: { text: null },
      type: 'datetime',
      dateTimeLabelFormats: {
        hour: $translate.instant('sharedModules.dateTimeFormats.chart.hour'),
        day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
        week: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
      }
    },
    yAxis: {
      title: { text: null },
      min: 0,
      labels: {
        formatter: function() {
          let suffix, valueDecimals;
          suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
          valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
          return $window.Highcharts.numberFormat(this.value, valueDecimals) + suffix;
        }
      }
    }
  }, baseChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/chronological_chart_v2_config.service.js